import React from 'react';

const LoadingIndicator = () => (
  <div className="nd-loading-indicator">
    Loading...
  </div>
);

export default LoadingIndicator;
